import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth';
import masterdataReducer from './masterdata';
import memberDataReducer from './memberdata';
import brokerConfigReducer from './brokerconfig';
import addClaimConfigReducer from './addClaim';
import memberManagerReducer from './memberManager';
import navbarReducer from './navbar';

const store = configureStore({
  reducer: {
    auth: authReducer,
    addClaim: addClaimConfigReducer,
    memberData: memberDataReducer,
    masterdata: masterdataReducer,
    brokerconfig: brokerConfigReducer,
    memberManager: memberManagerReducer,
    navbar: navbarReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
